"use strict";

$(window).on("load", () => {
    anchorOffset();
    anchorOnLoad();
    fixedHeader();
    headerMenu();
    animation();
    teamItem();
    anchorScroll();
    contactsForm();
    if ($(window).innerWidth() < 768) {
        $(".wow").attr("data-wow-delay", ".2s");
    }
});

$(window).on("scroll", () => {
    fixedHeader();
});

$(window).on("resize", () => {
    anchorOffset();
    if ($(window).innerWidth() < 768) {
        $(".wow").attr("data-wow-delay", ".2s");
    }
});

function contactsForm() {

    function isEmail(email) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
    }
    $(".js-contacts-form").on("submit", function (e) {
        var isValidArray = [], isValid = 0;
        $(this).find(".js-contacts-valid").each((i, item) => {
            isValidArray.push(false);
            if ($(item).attr("data-type") == "text") {
                if ($(item).val().length == 0) {
                    $(item).addClass("error");
                    $(item).next(".field-error").addClass("active");
                    isValidArray[i] = false;
                }
                else {
                    $(item).removeClass("error");
                    $(item).next(".field-error").removeClass("active");
                    isValidArray[i] = true;
                }
            }
            if ($(item).attr("data-type") == "checkbox") {
                if ($(item).prop("checked") == false) {
                    $(item).closest(".checkbox").next(".field-error").addClass("active");
                    isValidArray[i] = false;
                }
                else {
                    $(item).closest(".checkbox").next(".field-error").removeClass("active");
                    isValidArray[i] = true;
                }
            }
            if ($(item).attr("data-type") == "email") {
                if (!isEmail($(item).val())) {
                    $(item).addClass("error");
                    $(item).next(".field-error").addClass("active");
                    isValidArray[i] = false;
                }
                else {
                    $(item).removeClass("error");
                    $(item).next(".field-error").removeClass("active");
                    isValidArray[i] = true;
                }
            }
        });
        for (var i = 0; i < isValidArray.length; i++) {
            if (isValidArray[i] == true) {
                isValid++;
            }
        }
        // FORM SUCCESS
        if (isValid == isValidArray.length) {
            $(".contacts-form").slideUp(330);
            $(".contacts-success").slideDown(330);
            // $.post("form.php", $(this).formSerialize());
        }
        return false;
    })
    $(".js-contacts-valid").each((i, item) => {
        if ($(item).attr("type") == "checkbox") {
            $(item).on("change", function () {
                $(item).closest(".checkbox").next(".field-error").removeClass("active");
            });
        }
        $(item).keyup(function () {
            if ($(item).val().length > 0) {
                $(item).removeClass("error");
                $(item).next(".field-error").removeClass("active");
            }
        })
    })
}

function anchorOffset() {
    window.anchorOffsetVal = 130;
    if ($(window).innerWidth() < 1451) {
        window.anchorOffsetVal = 110;
    }
    else if ($(window).innerWidth() < 768) {
        window.anchorOffsetVal = 80;
    }
}
function anchorOnLoad() {
    if (window.location.hash != '') {
        setTimeout(() => {
            $('html, body').animate({
                scrollTop: $("[data-id='" + window.location.hash + "']").offset().top - window.anchorOffsetVal
            }, 800);
        }, 200);
    }
}
function anchorScroll() {
    $(".js-anchor").on('click', function (e) {
        var hash = $(this).attr("href");
        if (hash != "") {
            if ($("[data-id='" + hash.substring(hash.indexOf('#')) + "']").length) {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: $("[data-id='" + hash.substring(hash.indexOf('#')) + "']").offset().top - window.anchorOffsetVal
                }, 800);
            }
        }
    });
}

function teamItem() {
    $(".team-item__toggle").on("click", function (e) {
        e.preventDefault();
        $(this).closest(".team-item").stop().toggleClass("active");
        $(this).closest(".team-item").find(".team-item__preview").stop().slideToggle(330);
        $(this).closest(".team-item").find(".team-item__content").stop().slideToggle(330);
    });
}

function animation() {
    function afterReveal(el) {
        el.addEventListener('animationend', function () {
            if ($(el).attr("class").split(' ')[0] == "index-work__items") {
                workAnime();
            }
        });
    }
    $(".header").addClass("anime");
    new WOW({ callback: afterReveal }).init();
}

function workAnime() {
    function workAnimeMain() {
        $(".index-work__item-circle circle, .index-work__item-line-anime").removeAttr("style");
        $(".index-work__item-circle circle").attr({ "stroke-dasharray": window.circleVal, "stroke-dashoffset": window.circleVal });
        if (!$(".index-work__content").hasClass("active")) {
            $(".index-work__content").addClass("active")
        }
        if (!$(".index-work__content").hasClass("anime")) {
            $(".index-work__content").addClass("anime")
        }
        $(".index-work__item").each((i, item) => {
            window["workCircleTime" + i] = setTimeout(() => {
                $(".index-work__item-circle circle").css("transition", "stroke-dashoffset 2s linear")
                $(item).find(".index-work__item-circle circle").attr({ "stroke-dashoffset": "0px" });
            }, i * 2000);
            window["workLineTime" + i] = setTimeout(() => {
                if ($(window).innerWidth() < 768) {
                    $(item).find(".index-work__item-line-anime").css({ "width": "4px", "height": $(item).find(".index-work__item-line").innerHeight(), "transition": "height 1s linear" });
                }
                else {
                    $(item).find(".index-work__item-line-anime").css({ "width": $(item).find(".index-work__item-line").innerWidth(), "height": "4px", "transition": "width 1s linear" });
                }
            }, (i * 2000) + 1000);
        });
        window.workInterval = setInterval(() => {
            $(".index-work__content").toggleClass("active");
            if ($(".index-work__content").hasClass("active")) {
                $(".index-work__item").each((i, item) => {
                    window["workCircleTime" + i] = setTimeout(() => {
                        $(item).find(".index-work__item-circle circle").attr({ "stroke-dashoffset": "0px" });
                    }, i * 2000);
                    window["workLineTime" + i] = setTimeout(() => {
                        if ($(window).innerWidth() < 768) {
                            $(item).find(".index-work__item-line-anime").css({ "width": "4px", "height": $(item).find(".index-work__item-line").innerHeight(), "transition": "height 1s linear" });
                        }
                        else {
                            $(item).find(".index-work__item-line-anime").css({ "width": $(item).find(".index-work__item-line").innerWidth(), "height": "4px", "transition": "width 1s linear" });
                        }
                    }, (i * 2000) + 1000);
                });
            }
            else {
                $(".index-work__item").each((i, item) => {
                    window["workCircleTime" + i] = setTimeout(() => {
                        $(item).find(".index-work__item-circle circle").attr({ "stroke-dashoffset": window.circleVal });
                    }, i * 2000);
                    window["workLineTime" + i] = setTimeout(() => {
                        if ($(window).innerWidth() < 768) {
                            $(item).find(".index-work__item-line-anime").css({ "width": "4px", "height": "0", "transition": "height 1s linear" });
                        }
                        else {
                            $(item).find(".index-work__item-line-anime").css({ "width": "0", "height": "4px", "transition": "width 1s linear" });
                        }
                    }, (i * 2000) + 2000);
                });
            }
        }, 7000);
    }
    function workAnimeStart() {
        if ($(".index-work__content").length) {
            clearTimeout(window["workCircleTime0"]);
            clearTimeout(window["workCircleTime1"]);
            clearTimeout(window["workCircleTime2"]);
            clearTimeout(window["workLineTime0"]);
            clearTimeout(window["workLineTime1"]);
            clearTimeout(window["workLineTime2"]);
            clearInterval(window.workInterval);
            $(".index-work__content").removeClass("active anime");
            workLines();
            workAnimeMain();
        }
    }
    document.addEventListener('visibilitychange', function () {
        if (!document.hidden) {
            workAnimeStart();
        }
    });
    workAnimeStart();
    workAnimeStart();
    $(".index-work__item-media").addClass("active");
    var windowWidth = $(window).width();
    $(window).on("resize", () => {
        if ($(window).width() != windowWidth) {
            windowWidth = $(window).width();
            workAnimeStart();
        }
    });
}

function workLines() {
    if ($(window).innerWidth() > 767) {
        var width = $(".index-work__item-img").eq(1).offset().left - $(".index-work__item-img").eq(0).offset().left - $(".index-work__item-img").innerWidth() + 2;
        var lastWidth = $(window).innerWidth() - $(".index-work__item-img").eq(2).offset().left - $(".index-work__item-img").innerWidth() + 2;
        $(".index-work__item-line").each((i, item) => {
            $(item).removeAttr("style");
            $(item).find("line").removeAttr("x2");
            $(item).find("line").removeAttr("y2");
            $(item).css("width", width + "px");
            $(item).find("line").attr("x2", width);
            if (i == 2) {
                if (lastWidth < 345) {
                    $(item).css("width", lastWidth);
                    $(item).find("line").attr("x2", lastWidth);
                }
                else {
                    $(item).css("width", 345);
                    $(item).find("line").attr("x2", 345);
                }
            }
        });
    }
    else {
        var height = $(".index-work__item-img").eq(1).offset().top - $(".index-work__item-img").eq(0).offset().top - $(".index-work__item-img").innerHeight();
        $(".index-work__item-line").each((i, item) => {
            $(item).removeAttr("style");
            $(item).find("line").removeAttr("x2");
            $(item).find("line").removeAttr("y2");
            $(item).css({ "height": height + "px" });
            $(item).find("line").attr("y2", height);
            if (i == 2) {
                $(item).css("height", 110);
                $(item).find("line").attr("y2", 110);
            }
        });
    }
    window.circleVal = 2 * 3.14 * (($(".index-work__item-circle").innerWidth() / 2) - 4) + "px";
    $(".index-work__item-circle circle").attr({ "r": ($(".index-work__item-circle").innerWidth() / 2) - 4 + "px" });
    $(".index-work__item-circle-main circle").attr({ "r": ($(".index-work__item-circle").innerWidth() / 2) - 4 + "px" });
}

function headerMenu() {
    $(".header-burger").on("click", function () {
        $(".header-drop").stop().slideToggle();
        $(this).stop().toggleClass("active");
        $("html").stop().toggleClass("overflow");
    })
    $(window).on("resize", () => {
        if ($(window).innerWidth() >= 1200) {
            $(".header-drop").removeAttr("style");
            $("html").removeClass("overflow")
            $(".header-burger").removeClass("active");
        }
    })
}

function fixedHeader() {
    if ($(window).scrollTop() > 0) {
        $(".header").addClass("fixed");
    }
    else {
        $(".header").removeClass("fixed");
    }
}